import { useProfile } from "@brg/auth"
import { ExternalLink } from "@brg/ui"
import { useTranslation } from "react-i18next"
import styled from "styled-components"


const MainContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 48px;
    padding: 40px 80px;
    flex-direction: column;
    align-items: center;

    div {
        display: flex;
        width: 100%;
        justify-content: center;
    }
`

const MainText = styled.div`
    display: flex;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.6px;
`

const CreateText = styled.div`
    margin-top: 16px;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
`

const GalleryLinkButton = styled.div`
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 48px;
    border-radius: 3px;
    background: #151514;
    cursor: pointer;
    color: #fff;
`

const EmptyModal = ({text}: {text: string}) => {

    const {t} = useTranslation()
    const {accountId: id} = useProfile() || {accountId: ''}

    return <MainContainer>
        <MainText>
            {text}
        </MainText>
        <CreateText>
            {t('project_edit.create_calendar_or_collection')}
        </CreateText>
        <ExternalLink to={`${process.env.REACT_APP_URL_GALLERY}/collection/${id}?shouldForcedLogin=true&saveLoginUrl=true`} target="_blank">
            <GalleryLinkButton>
                {t('pagination.go')}
            </GalleryLinkButton>
        </ExternalLink>        
    </MainContainer>
}

export default EmptyModalimport { useProfile } from "@brg/auth"
import { ExternalLink } from "@brg/ui"
import { useTranslation } from "react-i18next"
import styled from "styled-components"


const MainContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 48px;
    padding: 40px 80px;
    flex-direction: column;
    align-items: center;

    div {
        display: flex;
        width: 100%;
        justify-content: center;
    }
`

const MainText = styled.div`
    display: flex;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.6px;
`

const CreateText = styled.div`
    margin-top: 16px;
    color: #151514;
    text-align: center;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.34px;
`

const GalleryLinkButton = styled.div`
    margin-top: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 13px 48px;
    border-radius: 3px;
    background: #151514;
    cursor: pointer;
    color: #fff;
`

const EmptyModal = ({text}: {text: string}) => {

    const {t} = useTranslation()
    const {accountId: id} = useProfile() || {accountId: ''}

    return <MainContainer>
        <MainText>
            {text}
        </MainText>
        <CreateText>
            {t('project_edit.create_calendar_or_collection')}
        </CreateText>
        <ExternalLink to={`${process.env.REACT_APP_URL_GALLERY}/collection/${id}?shouldForcedLogin=true&saveLoginUrl=true`} target="_blank">
            <GalleryLinkButton>
                {t('pagination.go')}
            </GalleryLinkButton>
        </ExternalLink>        
    </MainContainer>
}

export default EmptyModal